var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"seasidetms_theme_icon_slide_top",attrs:{"href":"#","id":"slide_top"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onSlideTop()}}},[_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }